// extracted by mini-css-extract-plugin
export default {"toggleContainer":"V6-z","toggleBtn":"W6-z","toggleLabel":"X6-z","tooltipContainer":"Y6-z","tooltipWrapper":"Z6-z","tooltipContentTop":"_6-z"};